import axios from "axios";

let lambdaPricingApi;
let lambdaEmailsApi;
let lambdaLostKeyApi;
let lambdaLicensesApi;
let lambdaInstallSurveyApi;
let lambdaUninstallSurveyApi;
let lambdaPurchaseSurveyApi;

// Skip build, the code should only run on browser side only
if (typeof window !== "undefined") {
  lambdaEmailsApi =
    window.location.hostname === "localhost"
      ? "https://webapi-dev.screenpresso.com/v1/emails" // Dev
      : "https://webapi.screenpresso.com/v1/emails"; // Prod

  lambdaLostKeyApi =
    window.location.hostname === "localhost"
      ? "https://webapi-dev.screenpresso.com/v1/lost-key" // Dev
      : "https://webapi.screenpresso.com/v1/lost-key"; // Prod

  lambdaPricingApi =
    window.location.hostname === "localhost"
      ? "https://webapi-dev.screenpresso.com/v1/2checkout" // Dev
      : "https://webapi.screenpresso.com/v1/2checkout"; // Prod

  lambdaLicensesApi =
    window.location.hostname === "localhost"
      ? "https://webapi-dev.screenpresso.com/v1/activations" // Dev
      : "https://webapi.screenpresso.com/v1/activations"; // Prod

  lambdaInstallSurveyApi =
    window.location.hostname === "localhost"
      ? "https://webapi-dev.screenpresso.com/v1/survey-legacy/install" // Dev
      : "https://webapi.screenpresso.com/v1/survey-legacy/install"; // Prod

  lambdaUninstallSurveyApi =
    window.location.hostname === "localhost"
      ? "https://webapi-dev.screenpresso.com/v1/survey-legacy/uninstall" // Dev
      : "https://webapi.screenpresso.com/v1/survey-legacy/uninstall"; // Prod

  lambdaPurchaseSurveyApi =
    window.location.hostname === "localhost"
      ? "https://webapi-dev.screenpresso.com/v1/survey-legacy/purchase" // Dev
      : "https://webapi.screenpresso.com/v1/survey-legacy/purchase"; // Prod
}

export const submitInstallSurveyForm = (formData) => {
  if (!formData.txtEmailAddress || formData.txtEmailAddress.trim() === "") {
    // Empty email address is considered as invalid, so we remove it if it's empty
    formData.txtEmailAddress = undefined;
  }
  const awsPromise = axios
    .post(lambdaInstallSurveyApi, formData, {
      headers: {
        "Content-Type": "application/json",
      },
      validateStatus: (status) => status >= 200 && status <= 400,
    })
    .then((response) => {
      if (response.status !== 200 && response.status !== 201) {
        throw new Error(response.data.error || response.data.message);
      }
      return response.data;
    });

  return awsPromise;
};

export const submitUnInstallSurveyForm = (formData) => {
  if (!formData.txtEmailAddress || formData.txtEmailAddress.trim() === "") {
    // Empty email address is considered as invalid, so we remove it if it's empty
    formData.txtEmailAddress = undefined;
  }
  const awsPromise = axios
    .post(lambdaUninstallSurveyApi, formData, {
      headers: {
        "Content-Type": "application/json",
      },
      validateStatus: (status) => status >= 200 && status <= 400,
    })
    .then((response) => {
      if (response.status !== 200 && response.status !== 201) {
        throw new Error(response.data.error || response.data.message);
      }

      return response.data;
    });

  return awsPromise;
};

export const submitPurchaseSurveyForm = (formData) => {
  if (!formData.txtEmailAddress || formData.txtEmailAddress.trim() === "") {
    // Empty email address is considered as invalid, so we remove it if it's empty
    formData.txtEmailAddress = undefined;
  }
  const awsPromise = axios
    .post(lambdaPurchaseSurveyApi, formData, {
      headers: {
        "Content-Type": "application/json",
      },
      validateStatus: (status) => status >= 200 && status <= 400,
    })
    .then((response) => {
      if (response.status !== 200 && response.status !== 201) {
        throw new Error(response.data.error || response.data.message);
      }

      return response.data;
    });

  return awsPromise;
};

export const submitEmailRegistrationForm = (formData) => {
  const awsPromise = axios
    .post(lambdaEmailsApi, formData, {
      headers: {
        "Content-Type": "application/json",
      },
      validateStatus: (status) => status >= 200 && status <= 400,
    })
    .then((response) => {
      if (response.status !== 200) {
        throw new Error(response.data.error || response.data.message);
      }
    });

  return awsPromise;
};

export const submitLostKeyForm = (formData) => {
  const awsPromise = axios
    .post(lambdaLostKeyApi, formData, {
      headers: {
        "Content-Type": "application/json",
      },
      validateStatus: (status) => status >= 200 && status <= 400,
    })
    .then((response) => {
      if (response.status !== 200) {
        throw new Error(response.data.error || response.data.message);
      }

      return response.data;
    });

  return awsPromise;
};

export const upgradeForm = async ({ key }) => {
  if (!key || key.trim() === "") {
    throw new Error("Empty key");
  }
  return axios
    .get(`${lambdaLicensesApi}/${encodeURIComponent(key)}`, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response.data;
    });
};
